// @ts-check

import { onDomReady } from '../../utils/dom';
import { IFramesBlocker } from '../../vendor/ElementsBlocker/Blockers';

const elementsBlockerFolder = 'files/theme/js/modules/elementsBlocker';

function initializeBlocker() {
    new IFramesBlocker('dialog iframe', {
        button: {
            content: 'Akzeptieren & Inhalte laden',
        },
        styles: `${elementsBlockerFolder}/inIframeStyles.css`,
        message: {
            content:
                'Klicken Sie hier, um den Bewerbungs-Funnel zu laden. Wir möchten Sie darauf hinweisen, dass Daten (z.B. Ihre IP-Adresse) an die Perspective Software GmbH mit Sitz in Berlin, Deutschland übermittelt werden. Zu den <a target="_blank" href="https://kontakt.planbuero-f.de/elektrofachplaner-tga/consent-policy/">Cookie Richtlinien</a>.',
        },
        caching: false,
    });
}

onDomReady(() => {
    initializeBlocker();
});
